export default "__VITE_ASSET__g_5j8H87__"